import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

/** ----------------------------------------------------------------------------
 * SAVE MESSAGE PREFRENCES
 -----------------------------------------------------------------------------*/
export const saveMessagePreferencesRequested = () => ({
  type: SettingsActionTypes.SAVE_MESSAGE_PREFERENCES_REQUESTED,
  isSaving: true,
});

export const saveMessagePreferencesSuccess = response => ({
  type: SettingsActionTypes.SAVE_MESSAGE_PREFERENCES_SUCCESS,
  isSaving: false,
  isSuccess: response.isSuccess,
  message: response.message,
  settings: response.settings,
});

export const saveMessagePreferencesFailure = error => ({
  type: SettingsActionTypes.SAVE_MESSAGE_PREFERENCES_FAILURE,
  isSaving: false,
  error: true,
  status: error.response && error.response.status,
});

export default saveMessagePreferences(new SettingsService());

export function saveMessagePreferences(service) {
  return messagePreferences => (dispatch) => {
    dispatch(saveMessagePreferencesRequested());
    service.saveMessagePreferences(messagePreferences).then(
      response => dispatch(saveMessagePreferencesSuccess(response.data)),
      error => dispatch(saveMessagePreferencesFailure(error)),
    );
  };
}
